// Formateo € / % del dashboard PRM.
// Convención de unidades: el margen es SIEMPRE fracción (0.125); aquí se multiplica ×100 al mostrar.

const nfEur = new Intl.NumberFormat('es-ES', { maximumFractionDigits: 0 })
const nfPct = new Intl.NumberFormat('es-ES', { minimumFractionDigits: 1, maximumFractionDigits: 1 })

export function fmtEur (n) {
  return `${nfEur.format(Math.round(n || 0))} €`
}

// Número suelto, sin moneda (p. ej. horas): "14.167" / "568,04".
const nfNum = new Intl.NumberFormat('es-ES', { maximumFractionDigits: 2 })
export function fmtNum (n) {
  return nfNum.format(Number(n) || 0)
}

// Símbolo de la divisa local (para importes en moneda local). Fallback: el propio código.
const CURRENCY_SYMBOLS = { EUR: '€', USD: '$', GBP: '£', CAD: 'C$', SEK: 'kr', JPY: '¥', CHF: 'CHF' }
export function currencySymbol (code) {
  return CURRENCY_SYMBOLS[code] || code || ''
}

// Importe en moneda local con su símbolo delante y 2 decimales: "kr 18.400.000,00".
const nfLocal = new Intl.NumberFormat('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
export function fmtLocalAmount (n, code) {
  return `${currencySymbol(code)} ${nfLocal.format(Number(n) || 0)}`
}

// n es una fracción: 0.125 -> "12,5 %"
export function fmtPct (n) {
  return `${nfPct.format((n || 0) * 100)} %`
}

// Importe € con signo: "+1.234 €" / "-1.234 €" (sin signo si es 0).
export function fmtEurSigned (n) {
  const v = n || 0
  return `${v < 0 ? '-' : v > 0 ? '+' : ''}${fmtEur(Math.abs(v))}`
}

// Puntos porcentuales con signo (v YA es número-porcentaje, no fracción): "+3,6 %".
export function fmtPctSigned (v) {
  const n = v || 0
  return `${n < 0 ? '-' : n > 0 ? '+' : ''}${nfPct.format(Math.abs(n))} %`
}

// Fecha y hora a "DD/MM/YYYY, HH:MM" (timestamps del historial de revisiones). Vacío si no hay valor.
export function fmtDateTime (v) {
  if (!v) return ''
  const d = new Date(v)
  if (isNaN(d.getTime())) return fmtDate(v)
  const p = (n) => String(n).padStart(2, '0')
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()}, ${p(d.getHours())}:${p(d.getMinutes())}`
}

// Fecha a DD/MM/YYYY. Acepta ISO (YYYY-MM-DD) o cualquier fecha parseable; si no, la deja igual.
export function fmtDate (v) {
  if (!v) return ''
  const iso = /^(\d{4})-(\d{2})-(\d{2})/.exec(v)
  if (iso) return `${iso[3]}/${iso[2]}/${iso[1]}`
  const d = new Date(v)
  if (!isNaN(d.getTime())) {
    const p = (n) => String(n).padStart(2, '0')
    return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()}`
  }
  return v
}
